const work=[
    // sample data format
    {
    "image": "https://i.postimg.cc/K8QFJGFw/1705389198122.jpg",
    "title": "Full Stack Developer",
    "company":"Soluperts.ca",
    "duration":"Aug. 2024 - Feb. 2025",
    "location":"Remote, Canada",
    "body":"Implementing the solution using MongoDB, Express.js, React.js,JavaScript and Node.js to create a scalable web system. This includes designing role-based access control, data consolidation, reporting, and user interfaces.Implementing the solution using MongoDB, Express.js, React.js,JavaScript and Node.js to create a scalable web system. This includes designing role-based access control, data consolidation, reporting, and user interfaces.",
    "user_id":1
  },

]
export default work;